import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function SEO({
  title,
  description,
  canonical,
  ogImage = 'https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/2500px-9484.jpg',
}) {
  const brandName = 'Krüger Wet Blaster ApS'
  const fullTitle = title
    ? title.includes('Krüger') || title.includes('Kryger')
      ? title
      : `${title} - ${brandName}`
    : brandName

  const defaultDesc =
    'Dansk produceret vandpoleringsmaskiner i høj kvalitet. Effektiv og kemi-fri metalrestaurering til auto og industri.'
  const fullDesc = description || defaultDesc

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <html lang="da" />
    </Helmet>
  )
}
